export default {"src":"/_next/static/media/39-icon.121f0fef.svg","height":44,"width":46,"blurWidth":0,"blurHeight":0};